import Individual from './individual/LabelReport';
import List from './list/LabelReports';

export default { List, Individual };
